<template>
  <div class="component-pack-table dealers">
    <div class="component-pack-table__head">
      <div class="main-description-title">
        <span>{{ titleModel }} verðlisti</span>
      </div>
      <div class="component-pack-table__buttons">
        <a-blank class="btn btn-dealer" :href="companyWebSite" target="_blank">
          <img src="/img/arrow.svg"/> Nánar um {{ model }}
        </a-blank>
        <a-blank :href="modelPriceList" class="btn btn-dealer">
          <img src="/img/arrow.svg"/>
          Sækja verðlista
        </a-blank>
      </div>
    </div>
    <div class="other-model pack-table">
      <b-table small :items="cars" :fields="tableHeadColumns" responsive="sm">
        <template v-slot:cell(id)="data">
          <template v-if="id == data.item.id">
            <div class="pack-icon">
              <img class="table-others-models__arrow" src="/img/arrow.svg"/>
            </div>
          </template>

          <template v-else-if="data.item.is_pack != 0">
            <div class="pack-icon">
              <img style="cursor: pointer;"
                   v-show="!curPack.includes(data.item.id)"
                   @click="open(data)"
                   src="/img/info-icon.svg"/>

              <img style="cursor: pointer;"
                   v-show="curPack.includes(data.item.id)"
                   @click="close(data)"
                   src="/img/close-info.svg"/>
            </div>
          </template>
        </template>

        <template v-slot:cell(model)="data">
          <div :class="{'pack-active': id == data.item.id}" class="model pack-name"
               @click="loadPack(data.item.id)">
            {{ data.item.model }}
          </div>
        </template>

        <!-- <template v-slot:cell(spending)="data">
            <div v-if="data.item.spending[0]" style="min-width: 100px">
                {{ data.item.spending[0] }}
                <sub v-if="data.item.spending">{{data.item.spending[1]}}</sub>
            </div>
        </template> -->

        <!-- <template v-slot:cell(tog)="data">
            {{ data.item.tog }}
        </template> -->

        <template v-slot:cell(transmision)="data">
          {{ data.item.transmision }}
        </template>

        <template v-slot:cell(consumption)="data">
          {{ data.item.consumption > 0 ? data.item.consumption : '' }} <sub
            v-if="data.item.consumption > 0">L/100km</sub>
        </template>

        <!-- <template v-slot:cell(power)="data">
            {{ data.item.power }}
        </template> -->

        <!-- <template v-slot:cell(accelaration)="data">
            {{ data.item.accelaration }}
            <sub v-if="data.item.accelaration">sek.</sub>
        </template> -->

        <template v-slot:cell(price)="data">
          <div class="other-model__cell-price">
            <a href="#" style="cursor: pointer;" @click.prevent="loadPack(data.item.id)"
               v-if="data.item.discountInt > 0"
               :class="{'pack-active': id == data.item.id}" class="pack-price">
              <span>{{ data.item.discount }}</span>
              <span class="start-price">{{ data.item.price }}</span>
            </a>

            <a href="#" v-else @click.prevent="loadPack(data.item.id)"
               :class="{'pack-active': id == data.item.id}" class="pack-price">
              {{ data.item.price }}
            </a>
          </div>
        </template>


        <template v-slot:row-details="row">
          <b-card :style="['text-align:left;']">
            <h2 style="text-align: left;">
              {{ row.item.title }}
            </h2>
            <dealer-packs :carPacks="row.item.package_description" :carName="row.item.name"/>
          </b-card>
        </template>
      </b-table>
    </div>
    <!-- <div style="text-align: right">
        <a-blank :href="modelPriceList" class="btn btn-dealer">
            <img src="/img/arrow.svg"/>
            Sækja verðlista
        </a-blank>
    </div> -->
    <div class="other-model__additional-text">
      <div>* Eydsla bL akstur <span class="value">** 0-100 km/klst</span></div>
      <div>Gert með fyrirvara um prentvillur. {{ car.company.name }} áskilur sér rétt til breytinga án fyrirvara á
        verði og búnaði. Vinsamlegast athugið að búnaður á mynd getur verið ólíkur búnaði bílsins.
      </div>
    </div>
  </div>
</template>

<script>
import ABlank from "@/components/ABlank.vue";
import DealerPacks from "@/components/Dealers/DealerPack.vue";
import {BTable} from 'bootstrap-vue'
import getBaseUrl from "../../helpers/getBaseUrl";
import {mapActions} from "vuex";

export default {
  components: {
    ABlank,
    DealerPacks,
    BTable
  },
  props: {
    car: {
      type: Object,
      default: () => {
      }
    },
    id: {
      type: [String, Number],
      default: null
    },
    iframe: {
      type: Boolean,
      default: false
    }
  },

  data: () => ({
    curPack: []
  }),

  methods: {
    ...mapActions({
      "saveStat": "SAVE_STATISTIC"
    }),
    open(data) {
      this.curPack.push(data.item.id)
      data.toggleDetails()
    },
    close(data) {
      const index = this.curPack.indexOf(data.item.id)
      this.curPack.splice(index, 1)
      data.toggleDetails()
    },
    loadPack(id) {
      if (this.iframe) {
        let props = this.$router.resolve({name: 'DealerCar', params: {id: id}});
        window.open(getBaseUrl() + props.href, '_blank');
      } else {
        if (this.car.status == 1) {
          this.$router.push({name: 'DealerCar', params: {id: id}});
        }
        if (this.car.status == 2) {
          this.$router.push({name: 'CarInStock', params: {id: id}});
        }
      }
    },
    carsSort() {
      return this.car && this.car.brands && this.car.brands.sort((a, b) => a.price - b.price);
    },
    showWebSite(){
      let data = {
        key: "view_company_site",
        id: ['Car', 'k7Car'].includes(this.$route.name) ? this.$route.params.id : this.$store.state.car_id,
        is_old: this.$route.name == 'DealerCar' ? 0 : 1
      };

      this.saveStat(data);
    }
  },
  computed: {
    cars() {
      const prices = this.carsSort();

      return (
          prices &&
          prices.map(car => {
            const tog = car.tog > 0 ? car.tog : 0;
            const title = car.package_name === 'Staðalbúnaður' ? 'Staðalbúnaður' : 'Búnaður í ' + car.package_name +
                (car.parent_package_name && car.parent_package_name.length ? ' umfram ' + car.parent_package_name : '')

            let model = car.model_name ? car.model_name + ' ' + car.package_name : car.package_name;
            if (!model) {
              model = 'Staðalbúnaður';
            }
            if (this.$device.mobile()) {
              model = model.replace('Staðalbúnaður', 'Staðalbún.');
            }

            let fuel =car.fuel2 ? (car.fuel + ", " + car.fuel2) : car.fuel;
            if(car.fuel_filter_id === 9000){
              fuel = car.fuel2 ? (car.fuel + " " + car.fuel2) : car.fuel;
              fuel += ' Hybrid';

              fuel = fuel.replace("Rafmagn",'');
            }


            return {
              id: car && car.id,
              name: car.model_class + ' ' + car.model_name,
              model: model,//car.model_name ? car.model_name + ' ' + car.package_name : car.package_name,
              drif: car.drif,
              engine: car.engine > 0 ? parseFloat(car.engine > 100 ? car.engine / 1000 : car.engine).toFixed(1) + "L" : 0,
              fuel: fuel,
              // spending: car.affinity && car.affinity.length ? [car.affinity, 'km.'] : car.consumption ? [car.consumption, 'L/100 km'] : null,
              consumption: parseFloat(car.consumption),
              transmision: car.transmision + (car.transmision_description ? '. ' + car.transmision_description : ''),
              tog: (tog ? tog : '-') + (car.horse_power ? ' - ' + car.horse_power : ''),
              // power: car.horse_power,
              // accelaration: car.accelaration,
              price: car.price_hide == 0 && car.price > 0
                  ? parseInt(car.price).format() + " kr."
                  : car.check_price == 1 ? 'Leitið til sölumanna' : "Sérpöntun",
              discount: car.discount ? parseInt(car.discount).format() + " kr." : '',
              discountInt: car.discount,
              package_description: car.package_description,
              package_name: car.package_name,
              parent_package_name: car.parent_package_name,
              title: title,
              battery_capacity: car.battery_capacity ? car.battery_capacity + ' kWh' : null,
              affinity: car.affinity ? car.affinity + ' km' : null
            };
          })
      );
    },
    hasCarsSpending() {
      return this.cars && this.cars.some(car => car.spending)
    },
    hasCarsAccelaration() {
      return this.cars && this.cars.some(car => car.accelaration)
    },
    hasCarsTog() {
      return this.car && this.car.brands && this.car.brands.some(car => car.tog)
    },
    hasCarsTransmision() {
      return this.cars && this.cars.some(car => car.transmision)
    },
    hasCarsPower() {
      return this.cars && this.cars.some(car => car.power)
    },
    hasCarsDrif() {
      return this.cars && this.cars.some(car => car.drif)
    },
    hasCarsFuel() {
      return this.cars && this.cars.some(car => car.fuel)
    },
    hasCarsConsumption() {
      return this.cars && this.cars.some(car => car.consumption)
    },
    hasCarsPrice() {
      return this.cars && this.cars.some(car => car.price)
    },
    hasEngine() {
      return this.cars && this.cars.some(car => car.engine)
      //return this.car && this.car.brands && this.car.brands.some(car => car.engine)
    },
    titleModel() {
      return `${this.car && this.car.brand} ${this.car && this.car.model_class}`
    },
    model() {
      return `${this.car && this.car.model_class}`
    },
    hasCompany() {
      return this.car && this.car.company
    },
    hasBatteryCapacity() {
      return this.car && this.car.battery_capacity
    },
    hasAffinity() {
      return this.car && this.car.affinity
    },
    companyName() {
      return this.hasCompany.name
    },
    companyWebSite() {
      return this.hasCompany && this.hasCompany.site ? `${this.$store.state.viewSiteLink}${this.car.id}&model_page=1` : ''
    },
    modelPriceList() {
      if (!(this.car && this.car.id)) return ''
      return `${this.$store.state.viewCarPdfLink}${this.car.id}`;
      // return this.car && this.car.model_pricelist;
    },
    tableHeadColumns() {
      const columns = []
      const filter = this.car && this.car.fuel_filter_id == 2 ? "Drægni" : "Eyðsla*";

      columns.push({key: 'id', label: ''});
      columns.push({key: 'model', label: "Útfærsla"});
      if (this.hasCarsDrif) {
        columns.push("drif")
      }

      if (this.car && this.hasEngine) {
        columns.push({key: 'engine', label: "Vél"})
      }
      if (this.hasCarsTransmision) {
        columns.push({key: 'transmision', label: "Girkassi"});
      }
      if (this.hasCarsFuel) {
        columns.push({key: 'fuel', label: "Eldsneyti"})
      }


      /*      if (this.hasCarsConsumption) {
              columns.push({key: 'consumption', label: "Eyðsla*"})
            }*/


      if (this.hasCarsSpending) {
        columns.push({key: 'spending', label: filter})
      }
      if (this.hasCarsTog) {
        columns.push({key: 'tog', label: 'Tog-Hö.'});
      }

      if (this.hasBatteryCapacity) {
        columns.push({
          label: 'Stærð rafhlöðu',
          key: 'battery_capacity'
        });
      }

      if (this.hasAffinity) {
        columns.push({
          label: 'Drægni allt að',
          key: 'affinity'
        });
      }


      /*if (this.hasCarsPower) {
        columns.push({key: 'power', label: "Hö."});
      }*/
      if (this.hasCarsAccelaration) {
        columns.push({key: 'accelaration', label: "Hröðun**"})
      }
      if (this.hasCarsPrice) {
        columns.push({key: 'price', label: "VERÐ FRÁ."})
      }

      return columns
    }
  }
};
</script>